import image1 from './1.webp';
import image2 from './2.webp';
import image3 from './3.webp';
import separatorBlueBottom from './marker-section-bot.svg';
import separatorBlueTop from './marker-section-top.svg';

export const valuesCardImages = [image1, image2, image3];
export { separatorBlueBottom, separatorBlueTop };
